export const FieldFillingTemplateService = {
  getData() {
    return [
      {
        id: 1,
        name: 'Название',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 2,
        name: 'Тип наряда',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 3,
        name: 'Объект',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 4,
        name: 'Участок',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 5,
        name: 'Исполнитель',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 6,
        name: 'Начало работы',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 11,
        name: 'Начало работы (План)',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 7,
        name: 'Завершение работы (План)',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 8,
        name: 'Завершение работы (Факт)',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      },
      {
        id: 9,
        name: 'Описание',
        nameActive: false,
        isRequired: false,
        allowReset: false,
        currentFunctions: []
      }
    ];
  },

  getFieldFillingTemplate() {
    return Promise.resolve(this.getData());
  }
};
